import React from "react";
import { useSetRecoilState } from "recoil";
import { downloadChallanData } from "../../api/incoming";
import { toastBgState, toastMessageState } from "../../utils/atoms/atoms";
import { closeModal } from "../../utils/funcs/common";

const toDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const ChallanDataDownloadModalBody = () => {
  const today = React.useMemo(() => new Date(), []);
  const [startDate, setStartDate] = React.useState(
    toDateInputValue(new Date(today.getFullYear(), today.getMonth(), 1))
  );
  const [endDate, setEndDate] = React.useState(toDateInputValue(today));
  const [isDownloading, setIsDownloading] = React.useState(false);
  const setToastBg = useSetRecoilState(toastBgState);
  const setToastMessage = useSetRecoilState(toastMessageState);

  const handleDownload = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!startDate || !endDate) {
      setToastBg("danger");
      setToastMessage("Select both dates for the challan download");
      return;
    }
    if (startDate > endDate) {
      setToastBg("danger");
      setToastMessage("The start date cannot be after the end date");
      return;
    }

    try {
      setIsDownloading(true);
      await downloadChallanData(startDate, endDate);
      closeModal("challanDataModal");
      setToastBg("success");
      setToastMessage("Challan data downloaded");
    } catch (error: any) {
      setToastBg("danger");
      setToastMessage(error.message || "Failed to download challan data");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <form onSubmit={handleDownload}>
      <div className="row g-3">
        <div className="col-12 col-md-6">
          <label htmlFor="challan-data-start-date" className="form-label">
            Start Date
          </label>
          <input
            id="challan-data-start-date"
            type="date"
            className="form-control"
            value={startDate}
            max={endDate}
            onChange={(event) => setStartDate(event.target.value)}
            required
          />
        </div>
        <div className="col-12 col-md-6">
          <label htmlFor="challan-data-end-date" className="form-label">
            End Date
          </label>
          <input
            id="challan-data-end-date"
            type="date"
            className="form-control"
            value={endDate}
            min={startDate}
            max={toDateInputValue(today)}
            onChange={(event) => setEndDate(event.target.value)}
            required
          />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button
          type="submit"
          className="styled-btn--std border-0"
          disabled={isDownloading}
        >
          {isDownloading ? "Downloading..." : "Download"}
        </button>
      </div>
    </form>
  );
};

export default ChallanDataDownloadModalBody;
